/**
 * Created by Vinicius
 */

import { Component, Input, OnDestroy, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortable, Sort } from '@angular/material/sort';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

import {
  BiometricHistoryData,
  BiometricHistoryView,
  BiometricHistoryFilter,
} from 'app/@core/interfaces/common/CalorieFriend/biometric-history';

@Component({
  selector: 'app-patient-biometric-history-list',
  templateUrl: './biometric-history-list.component.html',
  styleUrls: ['./biometric-history-list.component.scss'],
})
export class PatientBiometricHistoryListComponent implements OnDestroy {
  @Input() set patientId(value: number) {
    if (!value) return;
    this.paging.patientId = value;

    // default sort and load data initially
    this.sortor.sort({
      id: this.paging.sortBy,
      start: this.paging.orderBy,
    } as MatSortable);
  }
  @Input() set patientGuid(value: string) {
    if (!value?.length) return;
    this.paging.patientGuid = value;

    // default sort and load data initially
    this.sortor.sort({
      id: this.paging.sortBy,
      start: this.paging.orderBy,
    } as MatSortable);
  }
  @Input() patientIsPreferredUnitImperial: boolean = false;

  @ViewChild(MatPaginator, { static: true }) paginator?: MatPaginator;
  @ViewChild(MatSort, { static: true }) sortor?: MatSort;

  readonly displayedColumns = [
    'measureDateTime',
    'weight',
    'bodyFat',
    'bmi',
    'source',
  ];
  totalCount: number = 0;
  dataList: BiometricHistoryView[] = [];

  private unsubscribe$ = new Subject<void>();
  private paging: BiometricHistoryFilter = {
    sortBy: 'measureDateTime',
    orderBy: 'desc',
  };

  constructor(private biometricHistoryService: BiometricHistoryData) {}

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onSortChanged(sort: Sort): void {
    this.paging.sortBy = sort.active;
    this.paging.orderBy = sort.direction;
    this.loadDataList(true);
  }

  loadDataList(pagination: boolean = false): void {
    if (!this.paging.patientId && !this.paging.patientGuid) return;

    if (!pagination && this.paginator) this.paginator.pageIndex = 0;
    this.paging.pageNumber = pagination
      ? this.paginator?.pageIndex + 1 ?? 1
      : 1;
    this.paging.pageSize = this.paginator?.pageSize ?? 10;

    this.biometricHistoryService
      .list(this.paging)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        this.totalCount = res.totalCount;
        this.dataList = res.items;
      });
  }

  weight(weight: number): string {
    return this.patientIsPreferredUnitImperial
      ? Math.round((weight / 0.453592) * 10) / 10 + ' lbs'
      : weight + ' kg';
  }
}
